module.exports = __webpack_public_path__ + "img/icon-survey.c41d5c21.svg";